export function TargetDisabledIcon({ size = 32 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <g transform="translate(5 2)">
        <g id="Group">
        <path id="Vector" d="M12.5306 8.69202C14.6547 8.69202 16.3766 6.9701 16.3766 4.84601C16.3766 2.72192 14.6547 1 12.5306 1C10.4065 1 8.68457 2.72192 8.68457 4.84601C8.68457 6.9701 10.4065 8.69202 12.5306 8.69202Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path id="Vector_2" d="M12.5313 8.69336V16.3854H18.3003C18.8103 16.3854 19.2994 16.588 19.66 16.9486C20.0207 17.3092 20.2233 17.7984 20.2233 18.3084V26.0004" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path id="Vector_3" d="M7.7237 12.5381C6.50877 12.5393 5.31683 12.8694 4.27431 13.4933C3.2318 14.1171 2.3776 15.0116 1.80233 16.0817C1.22705 17.1518 0.952163 18.3577 1.00681 19.5714C1.06147 20.7851 1.44362 21.9613 2.11274 22.9754C2.78186 23.9895 3.71299 24.8035 4.80736 25.3312C5.90172 25.8588 7.11851 26.0804 8.32863 25.9725C9.53876 25.8645 10.6971 25.431 11.6808 24.7179C12.6644 24.0049 13.4367 23.0389 13.9158 21.9223" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </g>
      </g>
    </svg>
  )
}
